import { contactInviteListSchema, type ContactInvite } from '@secretario/shared';
import { apiFetch } from './http.js';

/** Convites mandados a contatos que ainda não usam o app (viram conversa aberta). */
export const INVITES_KEY = ['contact-invites'] as const;

export async function listInvites(): Promise<ContactInvite[]> {
  return contactInviteListSchema.parse(await apiFetch<unknown>('/v1/contacts/invites')).items;
}

/** Registra o convite (ou o reenvio). Falha aqui nunca impede o convite de sair. */
export async function recordInvite(contactId: string): Promise<void> {
  await apiFetch(`/v1/contacts/${encodeURIComponent(contactId)}/invite`, { method: 'POST' }).catch(
    () => undefined,
  );
}

export const dismissInvite = (contactId: string) =>
  apiFetch(`/v1/contacts/invites/${encodeURIComponent(contactId)}`, { method: 'DELETE' });
